<template>
	<v-dialog v-model="dialog" width="960">
		<template v-slot:activator="{ on: dialog }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn large icon v-on="{ ...tooltip, ...dialog }">
						<v-icon>mdi-upload</v-icon>
					</v-btn>
				</template>
				<span>Import</span>
			</v-tooltip>
		</template>

		<v-card raised class="pb-2">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Import</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false"><v-icon>mdi-close</v-icon> </v-btn>
			</v-toolbar>
			<v-card-text class="pt-6 pb-6">
				<v-form v-show="status == 'form'" ref="form" v-model="valid" lazy-validation>
					<v-row align="center">
						<v-col cols="3" class="py-0">
							<v-select v-model="type" :items="items" item-text="copy" item-value="value" label="Type" :rules="[(v) => !!v || 'Type is required']" required> </v-select>
						</v-col>
						<v-col class="py-0">
							<v-file-input v-model="file" accept=".csv" label="File" show-size :rules="[(v) => !!v || 'File is required']" required></v-file-input>
						</v-col>
						<v-col cols="auto" class="py-0">
							<v-btn color="green darken-2" class="white--text" @click="submit"> <v-icon left dark>mdi-upload</v-icon> Upload </v-btn>
						</v-col>
					</v-row>
					<v-row> </v-row>
				</v-form>

				<div v-show="status == 'uploading'">
					<h3 class="mb-4">Uploading...</h3>
					<v-progress-linear height="20" rounded :value="percent" :color="percent == 100 ? 'green darken-2' : 'indigo'"></v-progress-linear>
				</div>

				<div v-show="status == 'processing'">
					<h3 class="mb-4">Processing...</h3>
					<v-progress-linear height="20" rounded color="indigo" :indeterminate="isWorking" value="0" stream buffer="0"></v-progress-linear>
				</div>

				<v-alert v-show="status == 'success'" type="success" color="green darken-2" class="mb-0" prominent>
					<v-row align="center">
						<v-col>
							Your file has been successfully uploaded and processed.
						</v-col>
						<v-col cols="auto">
							<v-btn color="green lighten-5" class="black--text" @click="reset">
								Upload another file
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>

				<v-alert v-show="status == 'error'" dense prominent type="error" color="red darken-2" class="mb-0">
					<v-row align="center">
						<v-col>There was an error uploading your file.</v-col>
						<v-col cols="auto">
							<v-btn color="red lighten-5" class="black--text" @click="reset">
								Try Again
							</v-btn>
							<v-btn outlined href="https://www.wrike.com/workspace.htm?acc=2361792#path=request-forms&accountid=2361792&formid=287775" target="_blank" class="ml-4">
								Contact TechOps
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios';
import APIService from '@/services/APIService.js';

export default {
	data() {
		return {
			dialog: false,
			type: null,
			file: null,
			newFile: null,
			valid: false,
			percent: 0,
			status: 'form',
			checking: null,
			isWorking: true,
			items: [
				{ copy: 'Disavow', value: 'disavow' },
				{ copy: 'Majestic', value: 'majestic' },
				{ copy: 'Ahrefs', value: 'ahrefs' },
				{ copy: 'Google Search Console', value: 'gsc' },
				{ copy: 'Kerboo', value: 'kerboo' },
			],
			users: [],
			assignees: [],
		};
	},
	watch: {
		percent(percentage) {
			if (percentage >= 100) {
				this.status = 'processing';
				this.checkWorkerStatus();
			}
		},
		isWorking(status) {
			if (!status) {
				this.status = 'success';
				clearInterval(this.checking);
			}
		},
	},
	methods: {
		selectNewFile() {
			this.newFile = this.$refs.newFile.files[0];
			console.log(this.newFile);
		},
		submitNewFile() {
			console.log(this.newFile);
		},
		logFile() {
			console.log(this.file);
		},
		reset() {
			this.$refs.form.reset();
			this.percent = 0;
			this.status = 'form';
			this.checking = null;
			this.isWorking = true;
		},
		submit() {
			this.valid = this.$refs.form.validate();

			if (this.valid) {
				this.status = 'uploading';

				this.getUploadURL().then((response) => {
					console.log(response);
					if (response.status === 200) {
						this.status = 'processing';
					} else if (response.status) {
						this.stats = 'error';
					}
					this.uploadFile(response.data.url);
				});
			}
		},
		async uploadFile(url) {
			let component = this;
			let options = {
				headers: {
					'Content-Type': 'text/csv',
					Accept: '*/*',
				},
				onUploadProgress: function(progressEvent) {
					var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
					component.percent = percentCompleted;
				},
			};

			console.log(this.file);

			console.log(options);

			//Setup a try catch function to get a more specific error code

			//Also look at the vuetify file upload to make sure a file is going along with the payload.

			let formData = new FormData();
			formData.append('file', this.file);
			console.log(axios.defaults.headers);
			console.log(formData);
			//delete axios.defaults.headers.common["Authorization"];
			let response;
			try {
				response = await fetch(url, {
					method: 'PUT', // *GET, POST, PUT, DELETE, etc.
					headers: {
						'Content-Type': 'text/csv',
					},
					body: this.file, // body data type must match "Content-Type" header
				}).then((res) => {
					console.log(res);
					response = res;
					if (res.status === 200) {
						let intervalID = setInterval(() => {
							let path = process.env.VUE_APP_API_DISAVOWL + '/worker/status';
							axios.get(path).then((res) => {
								if (res.data.working) {
									this.status = 'processing';
								} else {
									this.status = 'success';
									clearInterval(intervalID);
								}
							});
						}, 3000);
					}
					return res;
				});
				console.log(response);
			} catch (e) {
				console.log(e);
			}
		},
		getUploadURL() {
			return APIService.getUploadURL({
				project: this.$route.params.id,
				type: this.type,
			});
		},
		uploadSuccess() {
			this.status = 'success';
		},
		uploadError() {
			this.status = 'error';
		},
		getWorkerStatus() {
			APIService.getWorkerStatus()
				.then((response) => {
					this.isWorking = response.data.working;
				})
				.catch((error) => {
					this.status = 'error';
					console.log(error);
				});
		},
		checkWorkerStatus() {
			this.checking = setInterval(() => {
				this.getWorkerStatus();
			}, 5000);
		},
		removeAssignee(item) {
			const index = this.assignees.indexOf(item);
			if (index >= 0) this.assignees.splice(index, 1);
		},
		fetchUsers() {
			APIService.getUsers().then((res) => {
				//To Do:  this needs to be called on creation of the modal somehow
				this.users = res.data.results;
			});
			//This method should grab all IC level users and place them into an array
			//The .text property should be added to all users as firstName + ' ' + lastName
			//This is because it allows for autocomplete to work
		},
	},
	created() {
		this.fetchUsers();
	},
};
</script>

<style lang="scss" scoped></style>
